// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useContext, useEffect} from 'react';
import styles from './form.module.less';
import cn from 'classnames';
import {Footer} from './footer';
import {t_methods, t_states} from './types';
import {Buttons} from './buttons';
import {perr} from 'hola_pub_util';
import Chevron_left from '../../../../hola/pub/img/hola2023/icons/16/chevron_left.svg';
import {Settings_context} from '../../../../hola/pub/settings_ctx';

interface i_login_buttons_props {
    on_click: (type:t_methods)=>void;
    go_to: (type:t_states, direction?: number)=>void;
    can_signup: boolean;
    blocks: {
        social?: {[propname: string]: boolean},
    };
    no_banner?: boolean;
    Banner?: JSX.Element;
    full_page: boolean;
    global_back?: boolean;
    img_set?: string;
}

export const State_login_buttons = (props: i_login_buttons_props)=>{
    const {theme} = useContext(Settings_context);
    useEffect(()=>{
        perr({id: 'www_login_view'});
    }, []);
    return <div className={styles.login_buttons}>
      <div className={styles.first_slide_title}>
        {props.global_back && <button className={styles.back_btn}
          onClick={()=>{
            location.href = location.href + '&hide_login=true';
          }}><Chevron_left/></button>}
        <p className={cn(styles.login_signup_text, theme.med)}>
          Welcome back</p>
        <p className={theme.p2}>Choose a log in method</p>
      </div>
      <Buttons type={'login'} blocks={props.blocks}
        on_click={props.on_click}/>
      {props.can_signup &&
        <p className={cn(theme.p3, styles.login_signup_switch)}>Don't have
          an account? <a className={styles.underline}
            onClick={e=>{
              e.preventDefault();
              props.go_to('signup_buttons');
            }}
            href='#'>Sign up</a></p>}
      <Footer label={'Log in'} google_terms={false} />
    </div>;
};
